<template>
	<div>
		<MChoice
			v-for="(choice, index) in choices"
			@input="$emit('input', $event)"
			:key="getChoiceID(index)"
			:inputAttrs="inputAttrs"
			:id="getChoiceID(index)"
			:name="name"
			:checked="isChecked(choice)"
			:value="choice.value"
			:label="choice.label"
			:disabled="isChoiceDisabled(choice)"
		/>
	</div>
</template>

<script>
import MChoice from './MChoice';

export default {
	name: 'MChoices',
	components: { MChoice },
	props: {
		name: {
			type: String,
			required: true
		},
		choices: {
			type: Array,
			required: true
		},
		value: {
			type: String,
			required: false,
			default: null
		},
		inputAttrs: {
			type: Object,
			required: false,
			default() {
				return {}
			}
		},
		disabled: {
			type: Boolean,
			required: false,
			default: false
		}
	},
	methods: {
		getChoiceID(index) {
			return 'id_' + this.name + '_' + index;
		},
		isChecked(choice) {
			return choice.value === this.value;
		},
		isChoiceDisabled(choice) {
			return choice.getOwnPropertyDescriptor('disabled')
				? choice.disabled
				: this.disabled;
		}
	}
}
</script>

<style scoped></style>
